import type { ButtonHTMLAttributes, ReactNode } from "react";

import { cx } from "../lib/cx";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "ghost" | "warning";
  children: ReactNode;
  loading?: boolean;
}

export function Button({ variant = "primary", className, children, loading, disabled, ...rest }: ButtonProps) {
  return (
    <button
      className={cx("button", `button-${variant}`, loading && "is-loading", className)}
      disabled={disabled || loading}
      {...rest}
    >
      <span className="button-label">{children}</span>
    </button>
  );
}
